import React, { useEffect, useState } from 'react';
import { permissions, paths } from 'src/paths';
import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import loader from 'src/components/LoaderImg/loader.gif';
import { getSignatureAccessAction } from 'src/redux/actions/documentationAction';
import { Modal } from '@mui/material';
import SucessModal from 'src/components/sucess-modal';
import { logoutUser } from 'src/routes/AuthContext';

const   RedirectTab = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userProfileResponse = useSelector((state: any) => state?.getTherapistProfileReducer);

  const {
    READ_DASHBOARD,
    READ_DEPARTMENT_DASHBOARD,
    READ_PATIENT,
    READ_DAILY_SESSION_NOTES,
    READ_THERAPIST_PLANNING,
    READ_THERAPIST_SCHEDULING,
    READ_MY_AVAILABILITY,
    READ_MONTH_END_ALERT,
  } = permissions;

  const {
    dashboard,
    departmentDashboard,
    patients,
    dailySessionNotes,
    therapyPlanning,
    schedule,
    laborManagement,
    physicianDashboard,
    monthDayAlert,
  } = paths;

  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    if (!userProfileResponse.getAdminProfile && !userProfileResponse.response) {
      //  setShowErrorModal(true);
      return;
    }
    const permissions = userProfileResponse.response?.data;
    const currentPermissions = permissions?.currentPermissions;
    switch (true) {
      case currentPermissions?.includes('Physician Dashboard'):
        navigate(physicianDashboard);
        break;
      case currentPermissions?.includes(READ_DASHBOARD):
        navigate(dashboard);
        break;
      case currentPermissions?.includes(READ_DEPARTMENT_DASHBOARD):
        navigate(departmentDashboard);
        break;
      case currentPermissions?.includes(READ_PATIENT):
        navigate(patients);
        break;
      case currentPermissions?.includes(READ_DAILY_SESSION_NOTES):
        navigate(dailySessionNotes);
        break;
      case currentPermissions?.includes(READ_THERAPIST_PLANNING):
        navigate(`${therapyPlanning.index}${therapyPlanning.details}`);
        break;
      case currentPermissions?.includes(READ_THERAPIST_SCHEDULING):
        navigate(schedule.therapistSchedule);
        break;
      case currentPermissions?.includes(READ_MY_AVAILABILITY):
        navigate(laborManagement.index);
        break;
      case currentPermissions?.includes(READ_MONTH_END_ALERT):
        navigate(monthDayAlert);
        break;
      default:
        setShowErrorModal(true);
        break;
    }
  }, [userProfileResponse]);

  const redirectToLoginPage = () => {
    logoutUser();
  };

  return (
    <>
      <img
        src={loader}
        alt="loading..."
        style={{ margin: 'auto', display: 'block' }}
      />

      <Modal open={showErrorModal}>
        <SucessModal
          title="Error"
          message={'Something went wrong! Please try again'}
          close={redirectToLoginPage}
          isSucess={false}
        />
      </Modal>
    </>
  );
};

export default RedirectTab;
